var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLiskReward = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_615_742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23V24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24V23C18.0751 23 23 18.0751 23 12Z",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_615_742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0515 3L10.4688 5.65019L15.6752 14.2741L11.3182 19H15.0091L19.0606 14.6077L12.0515 3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3535 16.3376L8.45306 14.2742L11.649 8.96767L10.0541 6.32983L5.06152 14.6078L9.11303 19.0001H10.4574L12.9262 16.3376H10.3535Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_615_742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "translate(5 3)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLiskReward);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lisk_reward.1b99d2125e1f40c082d476e26f8a8975.svg";